import { ConditionalPartial } from '../../../../utils';

import { CreateReturnsProcessConfigRequestDto } from './create-returns-process-config.request.dto';

/**
 * DTO for updating returns process configuration
 * All fields are optional for partial updates
 */
export class UpdateReturnsProcessConfigRequestDto extends ConditionalPartial(CreateReturnsProcessConfigRequestDto) {}
